const types = {
    login:'login',
    register: 'register'
}

export default types